import Styled from "styled-components";

export const Container = Styled.div`
border: 0.5px solid rgba(0,0,0,.2);
border-radius: 5px;
display:flex;
flex-direction: row;
width: 100%;
margin-bottom: 5px;

`;
export const Text = Styled.label`
font-size: 15px;
`;
export const ContentLeft = Styled.div`
display:flex;
padding: 2%;
color: blue;
flex-direction: column;
align-items: center;
justify-content: center;
border: 2px solid #009E3A;
border-width: 0px 2px 0px 0px;
`;
export const ContentRight = Styled.div`
justify-content: center;
display:flex;
padding: 1%;
flex-direction: column;

`;
export const Box = Styled.div`
display:flex;
`;
export const ButtonPro = Styled.button`
`;